<template>
  <div class="entry">
    <div v-if="YHSwitchLogin">
      <div class="top">
        <div class="YH-login">{{ $t("login.YHLogin") }}</div>
        <i alt="logo" v-if="scanLoginShow" @click="YHSwitch" class="iconfont logo icon-saomiaoerweima"></i>
        <!-- <img src="@/assets/img/code.png" @click="YHSwitch" alt="logo" class="logo" /> -->
      </div>
      <el-form
        :model="loginForm"
        ref="loginForm"
        class="login-form"
        :rules="loginRules"
        v-loading="isSubmitting"
        element-loading-spinner="el-icon-loading"
      >
        <el-form-item prop="usr">
          <el-input v-model="loginForm.usr" clearable :placeholder="$t('login.usr')" ref="loginUsr" autocomplete="off" @keyup.enter.native="$refs.loginPwd.focus()">
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-yonghu"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="pwd">
          <el-input
            v-model.trim="loginForm.pwd"
            clearable
            type="password"
            autocomplete="off"
            :placeholder="$t('login.pwd')"
            ref="loginPwd"
            show-password
            class="clear_pwd"
            @keyup.enter.native="submitLogin"
          >
            <!-- @keyup.enter.native="$refs.loginCode.focus()" -->
            <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-mima1"></i></template>
          </el-input>
        </el-form-item>
        <el-form-item prop="isRem">
          <div class="accountFun">
            <div class="accountFunLeft">
              <el-checkbox v-model="loginForm.isRem"></el-checkbox>
              <div style="font-size: 16px;color: #595959">{{ $t("login.auto_login") }}</div>
              <!-- <div style="font-size: 16px;color: #595959">{{ $t("login.remember_pwd") }}</div> -->
            </div>
            <div class="accountFunRight">
              <div class="link-forgetPwd" @click="$emit('changeMode', 'retrieve')">{{ $t("login.forgotPwd") }}</div>
              <div class="link-forgetPwd" @click="$emit('changeMode', 'retrieveUser')">{{ $t("login.forgotUser") }}</div>
            </div>
          </div>
        </el-form-item>
        <div class="error-hollow">
          <span class="error">{{ errorMsg }}</span>
        </div>
        <el-form-item class="submit-container">
          <el-button class="login-solid" @click="submitLogin">
            <span class="loginName">{{ $t("login.login") }}</span>
          </el-button>
        </el-form-item>
        <div class="demo-container">
          <span :style="{ width: demoShow == true ? 'auto' : '100%', padding: $lang.currentLang =='fr_FR'||$lang.currentLang =='de_DE'?'0':''}" class="zhuce-hollow" @click="$emit('changeMode', 'signup')">
            <i class="iconfont icon-zhuce"></i>
            <span class="zhuce">{{ $t("signup.signup") }}</span>
          </span>
          <span :style="{padding: $lang.currentLang =='fr_FR'||$lang.currentLang =='de_DE'?'0':''}" class="shili-hollow" v-if="!icaApp && demoShow" @click="demoPlant">
            <i class="iconfont icon-yanshi"></i>
            <span class="sample">{{ $t("login.sample_station") }}</span>
          </span>
        </div>
        <!-- 微信登录 -->
        <!-- <div class="WeChat">
          <h3 class="weixin"><i style="font-size:20px" class="iconfont icon-weixin"></i><span>微信登录</span></h3>
        </div> -->
      </el-form>
      <!-- 验证码弹框 -->
      <demo-dialog width="400px" id="slideVerifyCode" :title="$t('login.code')" :visible.sync="showCaptcha" v-if="showCaptcha">
        <div slot="content">
          <slide-verify
            ref="slideblock"
            @success="onSuccess"
            @again="onAgain"
            @fulfilled="onFulfilled"
            @fail="onFail"
            @refresh="onRefresh"
            :slider-text="textSlider"
            :w="352"
            :l="64"
            :imgs="judgePathName"
            :accuracy="accuracy"
          ></slide-verify>
          <!-- <div>{{msg}}</div> -->
          <!-- <button class="btn" @click="handleClick">在父组件可以点我刷新哦</button> -->
        </div>
      </demo-dialog>
      <!-- 演示账号弹框 -->
      <demo-dialog width="400px" :title="$t('login.invitationLogin')" :visible.sync="showDemoDialog" v-if="showDemoDialog">
        <div slot="content">
          <el-form :model="demoForm" ref="demoForm" :rules="demoRules" class="yzmBox">
            <el-form-item prop="code">
              <el-input v-model.trim="demoForm.code" @keyup.enter.native="demoCodeLogin"></el-input>
            </el-form-item>
          </el-form>
          <div class="contact">
            <p class="dialog-line">{{ $t("login.no_invitation") }}</p>
            <p>
              {{ $t("signup.email") }}：
              <span class="color-theme">{{ emailEm }}</span>
            </p>
            <p>
              {{ $t("signup.phone") }}：
              <span class="color-theme">{{ teleph }}</span>
              ({{ telephName }})
            </p>
          </div>
        </div>
        <div slot="footer" class="dialog-footer" v-loading="isSubmitting" element-loading-spinner="el-icon-loading">
          <!-- <button
            class="button-hollow"
            @click="showDemoDialog = false"
            size="small"
          >{{$t('message.cancel')}}</button> -->
          <button class="button-solid" @click="demoCodeLogin" size="small">{{ $t("login.login") }}</button>
        </div>
      </demo-dialog>
      <!-- 申请验证码弹框1 -->
      <demo-dialog width="400px" :title="$t('login.invitationLogin')" :visible.sync="ApplyPlantCodeDialog" v-if="ApplyPlantCodeDialog">
        <div slot="content" class="PlantCode">
          <div class="contactElse">
            <p class="dialog-line">
              {{ $t("plantCode.haveDevice") }}
              <span class="color-theme" @click="$emit('changeMode', 'signup')">{{ $t("plantCode.goRegister") }}</span>
            </p>
            <p class="dialog-line">
              {{ $t("plantCode.useDemo") }}
              <span class="color-theme" @click="requestCode">{{ $t("plantCode.applyNow") }}</span>
            </p>
          </div>
          <el-form class="yzmInput" :model="demoForm" ref="demoForm" :rules="demoRules">
            <el-form-item prop="code">
              <el-input v-model.trim="demoForm.code" :placeholder="$t('plantCode.pleaseCode')" @keyup.enter.native="demoCodeLogin"></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer" v-loading="isSubmitting" element-loading-spinner="el-icon-loading">
          <button class="button-solid" @click="demoCodeLogin" size="small">{{ $t("login.login") }}</button>
        </div>
      </demo-dialog>
      <!-- 申请验证码弹框2 -->
      <demo-dialog :title="$t('plantCode.codeApplication')" :visible.sync="ApplyPlantInfo" v-if="ApplyPlantInfo" width="450px">
        <div slot="content" class="PlantCode">
          <el-form :model="ApplyForm" class="login-form" ref="ApplyForm" label-width="15px" :rules="ApplyFormRules">
            <el-form-item label=" " prop="applyName">
              <el-input v-model.trim="ApplyForm.applyName" clearable :placeholder="$t('plantCode.pleaseName')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-yonghu"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item label=" " prop="companyName">
              <el-input v-model.trim="ApplyForm.companyName" clearable :placeholder="$t('plantCode.PleaseCompanyName')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-gongsi-"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item label=" " prop="companyAddress">
              <el-input v-model.trim="ApplyForm.companyAddress" clearable :placeholder="$t('plantCode.PleaseCompanyAddress')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-dizhi"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item label=" " prop="phoneNumber">
              <el-input v-model.trim="ApplyForm.phoneNumber" clearable :placeholder="$t('plantCode.PleaseNumber')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-shouji1"></i></template>
              </el-input>
            </el-form-item>
            <el-form-item label=" " prop="email">
              <el-input v-model.trim="ApplyForm.email" clearable :placeholder="$t('plantCode.PleaseEmail')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-youxiang"></i></template>
              </el-input>
            </el-form-item>
            <!-- type="textarea" -->
            <el-form-item label=" " prop="reason">
              <el-input v-model.trim="ApplyForm.reason" clearable :placeholder="$t('plantCode.PleaseApplication')">
                <template slot="prefix"><i style="font-size:20px;color: #595959;" class="iconfont icon-btn_drawremark"></i></template>
              </el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer">
          <button class="button-solid" @click="submitApplyForm" size="small">{{ $t("account.submit") }}</button>
        </div>
      </demo-dialog>
    </div>
    <div v-if="SMSwitchLogin">
      <div class="top">
        <div class="SM-login">{{ $t("login.scan_login") }}</div>
        <i alt="logo" @click="SMSwitch" class="iconfont logo icon-zhanghaodenglu"></i>
        <!-- <img src="@/assets/img/account.png" @click="SMSwitch" alt="logo" class="logo" /> -->
      </div>
      <div v-if="SmartClient" class="loginErweima">
        <div id="qrcode" ref="qrcode" class="erweima"></div>
        <div style="display: flex;justify-content: center;margin-top: 20px;">
          <div style="display: flex;flex-direction:row;align-items: center;">
            <img src="@/assets/img/scanit.png" style="width:24px;height:24px;margin-right:8px;" />
            <div style="height:38px;font-size:14px;color:rgba(51,51,51,1);">
              <p>
                {{ $t("login.open") }}
                <!-- icaApp?350:175 -->
                <el-popover v-if="tgpropowerApp == false" popper-class="popoverApp" placement="bottom" trigger="hover">
                  <div :style="{marginBottom:icaApp==true?'10px' : '20px'}" class="appDownload">{{ $t("login.app_download") }}</div>
                  <img v-if="!icaApp" style="border: 1px dashed;width:150px;height:150px;" src="@/assets/img/appDownload.png" />
                  <div v-if="icaApp" style="display:flex;">
                    <div v-if="iosShow">
                      <div>ios</div>
                      <img style="border: 1px dashed;width:150px;height:150px;" :src="iosBg" />
                    </div>
                    <div v-if="androidShow">
                      <div>Android</div>
                      <img style="border: 1px dashed;width:150px;height:150px;" :src="androidBg" />
                    </div>
                  </div>
                  <span v-if="!icaApp" style="color:#1890ff;cursor: pointer;" slot="reference">{{ $t("login.SmartESS") }}</span>
                  <span v-if="icaApp&&XTechShow" style="color:#1890ff;cursor: pointer;" slot="reference">{{ $t("login.X_Tech") }}</span>
                  <span v-if="icaApp&&!XTechShow" style="color:#1890ff;cursor: pointer;" slot="reference">{{ $t("login.pv123") }}</span>
                </el-popover>
                <span v-if="tgpropowerApp" style="color:#1890ff;">Energy store</span>
              </p>
              <p>{{ $t("login.Scancode_login") }}</p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="erweima" class="loginErweima">
        <img src="@/assets/img/qrlogin.png" style="width:320px;height:320px;margin-top: 36px;" />
        <div style="display: flex;justify-content: center;margin-top: 20px;">
          <div style="display: flex;flex-direction:row;align-items: center;">
            <img src="@/assets/img/scanit.png" style="width:24px;height:24px;margin-right:8px;" />
            <div style="height:38px;font-size:14px;color:rgba(51,51,51,1);">
              <p>
                {{ $t("login.scanning") }}
                <span style="color:#1890ff;">{{ $t("login.success") }}</span>
              </p>
              <p>{{ $t("login.Pleaseconfirm_login") }}</p>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 系统公告 -->
    <sys-notice :dialogVisible="showNoticeVisible" @dialogVisibleSend="dialogVisibleFun" :title="sysTitle" width="500px">
      <template slot="content">{{ sysContent }}</template>
    </sys-notice>
  </div>
</template>
<script>
import QRCode from "qrcodejs2"
import cookie from "@/assets/js/cookie"
import demoDialog from "@/components/dialog"
import img0 from "@/assets/img/img.png"
import img1 from "@/assets/img/img1.png"
import img2 from "@/assets/img/img1.jpg"
import img3 from "@/assets/img/img5.jpg"
import imgYWY from "@/assets/img/imageYWY.png"
// import img2 from '@/assets/img/img2.jpg';
// import img3 from '@/assets/img/img3.jpg';
// import img4 from '@/assets/img/img4.jpg';
// import img5 from '@/assets/img/img5.jpg';
// import SIdentify from "@/components/identify/identify.vue";
import slideVerify from "@/components/slideVerify/slideVerify.vue"

// 系统公告
import sysNotice from "@/components/sysNotice/index"
import config from '@/assets/js/config';
// import axios from 'axios';

export default {
  name: 'login',
  components: {
    demoDialog,
    slideVerify,
    // SIdentify,
    sysNotice
  },
  props: {
    userInfo: {
      type: Object
    },
    XTechShow:{
      type: Boolean
    },
    iosBg:{
      type: String
    },
    androidBg:{
      type: String
    },
    iosShow:{
      type: Boolean
    },
    androidShow:{
      type: Boolean
    },
  },
  data() {
    // 验证码自定义验证规则
    // const validateVerifycode = (rule, value, callback) => {
    //   if (value === "") {
    //     callback(new Error(this.$t("retrieve.enter_code")));
    //   } else if (value.toLowerCase() !== this.identifyCode.toLowerCase()) {
    //     callback(new Error(this.$t("retrieve.Incorrect_code")));
    //   } else {
    //     callback();
    //   }
    // };
    return {
      // 系统公告
      showNoticeVisible: false,
      sysTitle: "",
      sysContent: "",
      // sysTitle:this.$t("sysnotice.title"),
      // sysTo:this.$t("sysnotice.to"),
      // sysContent:this.$t("sysnotice.content"),

      ApplyForm: {
        applyName: "",
        companyName: "",
        companyAddress: "",
        phoneNumber: "",
        email: "",
        reason: ""
      },
      ApplyFormRules: {
        // 用户名
        applyName: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 32,
            message: this.$t("login.usrformat"),
            trigger: "blur"
          }
        ],
        phoneNumber: [
          {
            required: true,
            message: this.$t("message.mobile_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("signup.mobileformat"),
            trigger: "blur"
          }
        ],
        email: [
          {
            required: true,
            message: this.$t("message.email_is_required"),
            trigger: "blur"
          },
          {
            max: 64,
            pattern: /^(?=\w+([-+.']\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$).{0,64}$/,
            message: this.$t("message.email_info"),
            trigger: "blur"
          }
        ],
        reason: [
          {
            required: true,
            message: this.$t("plantCode.reasonNotEmpty"),
            trigger: "blur"
          }
        ]
      },
      icaApp: false,
      ApplyPlantCodeDialog: false, //申请邀请码弹框
      ApplyPlantInfo: false, //申请邀请码的信息弹框
      tgpropowerApp: false,
      qrcodeUrl: "",
      code: "",
      qrcod: "",
      SmartClient: true,
      erweima: false,
      YHSwitchLogin: true,
      SMSwitchLogin: false,
      emailEm: "",
      teleph: "",
      telephName: "",
      // chars: [
      //   "0",
      //   "1",
      //   "2",
      //   "3",
      //   "4",
      //   "5",
      //   "6",
      //   "7",
      //   "8",
      //   "9",
      //   "A",
      //   "B",
      //   "C",
      //   "D",
      //   "E",
      //   "F",
      //   "G",
      //   "H",
      //   "I",
      //   "J",
      //   "K",
      //   "L",
      //   "M",
      //   "N",
      //   "O",
      //   "P",
      //   "Q",
      //   "R",
      //   "S",
      //   "T",
      //   "U",
      //   "V",
      //   "W",
      //   "X",
      //   "Y",
      //   "Z"
      // ],
      // fontstyle: {},
      // checked: false,
      // identifyCodes: [],
      // identifyCode: "",
      loginForm: {
        usr: this.userInfo && this.userInfo.usr,
        pwd: this.userInfo && this.userInfo.pwd,
        isRem: this.userInfo && this.userInfo.isRem
        // verifycode: ""
      },
      loginRules: {
        // verifycode: [
        //   { required: true, trigger: "blur", validator: validateVerifycode }
        // ],
        // 用户名
        usr: [
          {
            required: true,
            message: this.$t("message.uname_is_required"),
            trigger: "blur"
          },
          {
            min: 2,
            max: 32,
            message: this.$t("login.usrformat"),
            trigger: "blur"
          }
        ],
        // 密码
        pwd: [
          {
            required: true,
            message: this.$t("message.pwd_is_required"),
            trigger: "blur"
          },
          {
            min: 6,
            max: 32,
            message: this.$t("login.pwdformat"),
            trigger: "blur"
          }
        ]
      },
      // 示例账号登录表单
      demoForm: {
        code: ""
      },
      demoRules: {
        code: [
          {
            required: true,
            message: this.$t("message.invitation_is_required"),
            trigger: "blur"
          }
        ]
      },
      msg: "",
      textSlider: "",
      // imgs: [
      //   img0,
      //   img1
      //   // img2,
      //   // img3,
      //   // img4,
      //   // img5,
      // ],
      accuracy: 5, // 精确度小，可允许的误差范围小；为1时，则表示滑块要与凹槽完全重叠，才能验证成功。默认值为5
      showCaptcha: false,
      showDemoDialog: false,
      errorMsg: "", // 错误信息
      isSubmitting: false, // 正在提交登录请求
      demoShow:false,//演示显隐
      scanLoginShow:false,//扫码显隐
    }
  },
  created() {
    if (!sessionStorage.getItem('visitedFlag')) {
      // console.log('首次访问，清除节点信息')
      this.delNodeCookie('saveCurrentNode');
      sessionStorage.setItem('visitedFlag', '1');
    }
    if(this.userInfo&&this.userInfo.isRem){
      this.$nextTick(() => {
        this.onSuccess()
      })
    }
  },
  activated() {
    // 组件被 keep-alive 缓存后，每次切换回来会执行这里
    this.errorMsg = ""
  },
  mounted() {
    this.getlinkman()
    // 验证码初始化
    // this.identifyCode = "";
    // this.makeCode(this.identifyCodes, 4);
    this.getHostName()

    // 系统公告
    this.$request
      .get1(
        "getTask",
        {
          client: 1,
          client_account: 0,
          client_content: 2,
          client_language: this.$lang.currentLang == "zh_CN" ? 1 : 2
        },
        document.location.protocol + "//cps.eybond.com/cps/"
      )
      .then(res => {
        if (res.dat && res.dat.msgType == 2) {
          this.showNoticeVisible = true
          this.sysTitle = res.dat.title
          this.sysContent = res.dat.content
        }
      })
      .catch(e => {
        // console.log(e)
      })
  },
  computed: {
    judgePathName() {
      let hostname = window.location.hostname,arr=[]
      if (hostname.indexOf("poweringev") != -1) {
        arr = [imgYWY]
      }else if(hostname=='batteryevo.dessmonitor.com'){
        arr = [img2, img3]
      }else {
        arr = [img0, img1]
      }
      return arr
    },
  },
  methods: {
    // 关闭系统公告
    dialogVisibleFun() {
      //  console.log("close");
      this.showNoticeVisible = false
    },
    //标准定制功能显隐
    getHostName() {
      var hostname = window.location.hostname
      var loct=hostname.slice(0,3)
      if (hostname == "www.dessmonitor.com"||hostname == "ess.dev.eybond.com"||hostname == "ess.test.eybond.com") {
        this.demoShow = true
        this.scanLoginShow = true
      } else if (hostname == "tgpropower.dessmonitor.com") {
        this.tgpropowerApp = true
        this.demoShow = false
        this.scanLoginShow = true
      } else if (hostname == "monitoring2.icasolar.com") {
        this.icaApp = true
        this.demoShow = false
        this.scanLoginShow = true
      } else if (hostname == "x-tech.dessmonitor.com") {
        this.icaApp = true
        this.demoShow = false
        this.scanLoginShow = true
      } else{
        this.icaApp = true
        this.demoShow = false
        this.scanLoginShow = false
      }
    },
    delNodeCookie(name) {
      // 将cookie的过期日期设置为一个过去的时间，这样浏览器会自动删除该cookie
    document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:01 GMT;';
    },
    onSuccess() {
      // this.msg = 'login success'
      setTimeout(() => {
        this.showCaptcha = false
        this.$store.commit("logout") //清除cookie,sessionStorage, store中的信息
        cookie.delCookie("baseUrl")
        this.isSubmitting = true
        this.$request.verify(this.loginForm).then(res => {
          if (res.err==261) {
            if(config.env =="production"){
              if(cookie.getCookie('saveCurrentNode')&&cookie.getCookie('saveCurrentNode')=="web1.shinemonitor.com"){
                cookie.setCookie("saveCurrentNode", "web.shinemonitor.com")
              }else{
                cookie.setCookie("saveCurrentNode", "web1.shinemonitor.com")
              }
              this.$request.verify(this.loginForm).then(res=>{
                if (res.err==261) {
                  this.delNodeCookie('saveCurrentNode')
                  this.errorMsg = this.$t(`errCode.${res.err}`)
                } else if (res.dat) {
                  this.errorMsg = ""
                  cookie.setCookie("usr", JSON.stringify(res.dat.usr))
                  this.saveAuth(res.dat)

                  let formData = this.loginForm;
                  let userInfo = {
                    usr: formData.usr,
                    pwd: formData.pwd,
                    isRem: !!formData.isRem
                  };
                  cookie.setCookie('userInfo', JSON.stringify(userInfo), 7 * 24 * 60 * 60);
                  // cookie.delCookie("userInfo")
                  // if (userInfo.isRem) {
                  //   this.$filter.captureMessage('登录系统');
                  // }
                  // // this.$filter.captureMessage('登录系统');
                } else{
                  this.delNodeCookie('saveCurrentNode')
                  this.errorMsg = this.$t(`errCode.${res.err}`)
                }
              })
            }else{
              this.errorMsg = this.$t(`errCode.${res.err}`)
            }
          } else if (res.dat) {
            this.errorMsg = ""
            cookie.setCookie("usr", JSON.stringify(res.dat.usr))
            this.saveAuth(res.dat)

            let formData = this.loginForm;
            let userInfo = {
              usr: formData.usr,
              pwd: formData.pwd,
              isRem: !!formData.isRem
            };
            cookie.setCookie('userInfo', JSON.stringify(userInfo), 7 * 24 * 60 * 60);
            // cookie.delCookie("userInfo")
            // if (userInfo.isRem) {
            //   this.$filter.captureMessage('登录系统');
            // }
            // // this.$filter.captureMessage('登录系统');
          } else{
            this.errorMsg = this.$t(`errCode.${res.err}`)
          }
          this.isSubmitting = false
        }).catch(() => {
          this.isSubmitting = false
          this.errorMsg = this.$t(`errCode.3`)
        })
      }, 1000)
    },
    onFail() {
      // console.log("验证不通过")
      this.msg = ""
    },
    onRefresh() {
      // console.log("点击了刷新小图标")
      this.msg = ""
    },
    onFulfilled() {
      // console.log("刷新成功啦！")
    },
    onAgain() {
      // console.log("检测到非人为操作的哦！")
      this.msg = "try again"
      // 刷新
      this.handleClick()
    },
    handleClick() {
      this.$refs.slideblock.reset()
      this.msg = ""
    },
    qrcode() {
      this.$nextTick(() => {
        let qrcode = new QRCode("qrcode", {
          width: 320,
          height: 320, // 高度
          text: this.qrcodeUrl, // 二维码内容
          render: "canvas",
          background: "#f0f",
          foreground: "#ff0",
          correctLevel: 0
        })
        // console.log(qrcode)
      })
    },
    YHSwitch() {
      this.YHSwitchLogin = false
      this.SMSwitchLogin = true
      this.erweima = false
      this.SmartClient = true
      this.getDynamicQrKey()
    },
    SMSwitch() {
      this.YHSwitchLogin = true
      this.SMSwitchLogin = false
      this.erweima = false
      this.SmartClient = false
      clearInterval(this.interval)
      this.interval = null
    },
    demoPlant() {
      var hostname = window.location.hostname
      if (hostname == "www.dessmonitor.com") {
        this.ApplyPlantCodeDialog = true
        this.showDemoDialog = false
      } else {
        this.showDemoDialog = true
        this.ApplyPlantCodeDialog = false
      }
    },
    // 申请邀请码弹框
    requestCode() {
      this.ApplyPlantInfo = true
      this.ApplyPlantCodeDialog = false
      Object.keys(this.ApplyForm).forEach(key => (this.ApplyForm[key] = ""))
    },
    submitApplyForm() {
      this.$refs.ApplyForm.validate(valid => {
        if (!valid) return false
        let params = {
          applyName: this.ApplyForm.applyName,
          phoneNumber: this.ApplyForm.phoneNumber,
          email: this.ApplyForm.email,
          companyName: this.ApplyForm.companyName,
          companyAddress: this.ApplyForm.companyAddress,
          reason: this.ApplyForm.reason,
          status: "0",
          sysType: "1",
          createTime: this.$filter.formatDate(new Date(), "yyyy-MM-dd hh:mm:ss")
        }
        this.$request.vssPost(params).then(res => {
          if (res.err) {
            this.$message.error(this.$t(`errCode.${res.err}`))
          } else {
            this.$message.success(this.$t("plantCode.successfulApplication"))
            this.ApplyPlantInfo = false
          }
        })
      })
    },
    //获取邀请码联系人的联系方式
    getlinkman() {
      var hostname = window.location.hostname
      this.$request
        .getlink(
          "consultParam/getParam",
          {
            i18n: this.$lang.currentLang,
            // appID:"tgpropower.dessmonitor.com",
            appID: hostname
          },
          document.location.protocol + "//cfb.eybond.com/cfb/api/"
        )
        .then(res => {
          if (res.err === 0) {
            this.teleph = res.dat.phoneNum
            // this.telephName = res.dat.wechat;
            this.emailEm = res.dat.email
            this.telephName = this.$lang.currentLang == "zh_CN" ? res.dat.wechat : res.dat.englishName
          } else {
            this.emailEm = "market@eybond.com"
            this.teleph = "+86-0755-89992588"
            this.telephName = this.$t("login.linkman")
          }
        })
    },
    // 普通账号登录
    submitLogin() {
      this.$refs.loginForm.validate(valid => {
        if (!valid || this.isSubmitting) return false
        this.showCaptcha = true
        // cookie.delCookie("baseUrl");
        // this.isSubmitting = true;
        // this.$request.verify(this.loginForm).then(res => {
        //   if (res.err) {
        //     this.errorMsg = this.$t(`errCode.${res.err}`);
        //   } else if (res.dat) {
        //     this.errorMsg = "";
        //     this.saveAuth(res.dat);

        //     let formData = this.loginForm;
        //     // 记住用户名密码
        //     if (formData.isRem) {
        //       let userInfo = {
        //         usr: formData.usr,
        //         pwd: formData.pwd
        //       };
        //       cookie.setCookie("userInfo", JSON.stringify(userInfo));
        //     } else {
        //       cookie.delCookie("userInfo");
        //     }
        //   }
        //   this.isSubmitting = false;
        // });
      })
    },
    // 示例账号登录
    demoCodeLogin() {
      this.$refs.demoForm.validate(valid => {
        if (!valid || this.isSubmitting) return false

        this.isSubmitting = true
        this.$store.commit("logout") //清除cookie,sessionStorage, store中的信息
        this.$request.demoCodeLogin(this.demoForm.code).then(res => {
          if (res.err == 0) {
            this.saveAuth(res.dat)
          }else if(res.err == 11){
            this.$message.error(this.$t("login.no_validitycode"))
          }else{
            this.$message.error(this.$t(`errCode.${res.err}`))
          }
          // if (res.err) {
          //   this.$message.error(this.$t(`errCode.${res.err}`))
          // } else if (res.dat) {
          //   this.saveAuth(res.dat)
          // }
          this.isSubmitting = false
        })
      })
    },
    // 保存鉴权及用户信息
    saveAuth({ secret, token, role, expire,pprAuth }) {
      cookie
        .setCookie("secret", secret, expire)
        .setCookie("token", token, expire)
        .setCookie("role", role, expire)
        .setCookie("pprAuth", pprAuth, expire)
      sessionStorage.setItem("secret", secret);
      sessionStorage.setItem("token", token);
      sessionStorage.setItem("role", role);
      sessionStorage.setItem("pprAuth", pprAuth);
      this.$store.commit("saveAuth", {
        secret,
        token,
        role,
        pprAuth
      })
      sessionStorage.setItem("isLogin", true);
      sessionStorage.setItem("disPermissionsLogo", false);
      if(role==2){
        sessionStorage.removeItem('moduleArr')
        sessionStorage.removeItem('firstPageArr')
        sessionStorage.removeItem('secPageArr')
        sessionStorage.removeItem('buttonArr')
        this.$request.get("queryAccountInfo").then(res => {
          if (res.err === 0&&res.dat.permission&&res.dat.permission.length>0) {
            var moduleArr=[],firstPageArr=[],secPageArr=[],buttonArr=[]
            res.dat.permission.forEach(item => {
              if(item.isCheck)
               moduleArr.push(item.action);
              if(item.buttons){
                  for (var i = 0, length = item.buttons.length; i < length; i++) {
                    if(item.buttons[i].isCheck){
                      buttonArr.push(item.buttons[i].action)
                    }
                  }
              }
              item.first_menus.forEach(firstItem => {
                if(firstItem.isCheck)
                firstPageArr.push(firstItem.action);
                if(firstItem.buttons){
                    for (var i = 0, length = firstItem.buttons.length; i < length; i++) {
                      if(firstItem.buttons[i].isCheck){
                        buttonArr.push(firstItem.buttons[i].action)
                      }
                    }
                }
                firstItem.second_menus.forEach(secItem => {
                if(secItem.isCheck)
                secPageArr.push(secItem.action);
                if(secItem.buttons){
                    for (var i = 0, length = secItem.buttons.length; i < length; i++) {
                      if(secItem.buttons[i].isCheck){
                        buttonArr.push(secItem.buttons[i].action)
                      }
                    }
                }
              })
              })
            });
            sessionStorage.setItem("moduleArr", JSON.stringify(moduleArr));
            sessionStorage.setItem("firstPageArr", JSON.stringify(firstPageArr));
            sessionStorage.setItem("secPageArr", JSON.stringify(secPageArr));
            sessionStorage.setItem("buttonArr", JSON.stringify(buttonArr));
            sessionStorage.setItem("disPermissionsLogo", true);
          }
          this.redirect()
        })
      }else{
        this.redirect()
      }
    },
    // 登录成功后跳转
    redirect() {
      // 账号登录后判断账号是否已申请注销
      this.$request.get("logoutVerifiction").then(res => {
        if (res.err == 0) {
          this.errorMsg = this.$t("message.Logging_off")
        } else {
          // let redirect = this.$route.query.redirect || "/home"
          // this.$router.push(redirect)
          if(this.$store.state.user.role==2&&this.$store.state.user.isNewEdition){
            var arr = sessionStorage.getItem("moduleArr")?JSON.parse(sessionStorage.getItem("moduleArr")):[]
            if(arr.includes('overview')){
              this.$router.push("/home")
            }else if(arr.includes('device_manag')){
              this.$router.push("/adminNew/device")
            }else if(arr.includes('account_manag')){
              this.$router.push("/adminNew/account")
            }else if(arr.includes('alarm_manag')){
              this.$router.push("/adminNew/alarm")
            }else if(arr.includes('system_settings')){
              this.$router.push("/adminNew/setting")
            }else{
              this.$router.push("/home")
            }
          }else{
            this.$router.push("/home")
          }
        }
      })
    },
    // // 生成随机数
    // randomNum() {
    //   var idx = Math.ceil(Math.random() * 35);
    //   return this.chars[idx];
    // },
    // // 切换验证码
    // refreshCode() {
    //   this.identifyCode = "";
    //   this.makeCode(this.identifyCodes, 4);
    // },
    // // 生成四位随机验证码
    // makeCode(o, l) {
    //   for (let i = 0; i < l; i++) {
    //     this.identifyCode += this.randomNum();
    //   }
    // },
    //生成二维码
    getDynamicQrKey() {
      this.code = ""
      var codeLength = 32
      var selectChar = new Array(
        "_",
        0,
        1,
        2,
        3,
        4,
        5,
        6,
        7,
        8,
        9,
        "a",
        "b",
        "c",
        "d",
        "e",
        "f",
        "g",
        "h",
        "i",
        "j",
        "k",
        "l",
        "m",
        "n",
        "o",
        "p",
        "q",
        "r",
        "s",
        "t",
        "u",
        "v",
        "w",
        "x",
        "y",
        "z",
        "A",
        "B",
        "C",
        "D",
        "E",
        "F",
        "G",
        "H",
        "I",
        "J",
        "K",
        "L",
        "M",
        "N",
        "O",
        "P",
        "Q",
        "R",
        "S",
        "T",
        "U",
        "V",
        "W",
        "X",
        "Y",
        "Z"
      )
      for (var i = 0; i < codeLength; i++) {
        var charIndex = Math.floor(Math.random() * 63)
        this.code += selectChar[charIndex]
      }
      cookie.delCookie("baseUrl")
      this.qrcodeUrl = `http://web.shinemonitor.com/public/?action=qrLogin&plat=smartlan&key=${this.code}`
      this.qrcode()
      this.interval = setInterval(() => {
        this.$request
          .get("qrLogin", { plat: "smartlan", key: this.code })
          .then(res => {
            if (res.err == 6) {
              clearInterval(this.interval)
              this.interval = null
            } else if (res.err == 1033) {
              console.log("")
            } else if (res.err == 1040) {
              this.erweima = true
              this.SmartClient = false
            } else if (res.err == 0) {
              clearInterval(this.interval)
              this.interval = null
              this.saveAuth(res.dat)
            } else {
              this.$message.error(this.$t(`errCode.${res.err}`))
              clearInterval(this.interval)
              this.interval = null
            }
          })
          .catch(() => {
            clearInterval(this.interval)
            this.interval = null
          })
      }, 3000)
    }
  }
}
</script>

<style lang="less" scoped>
.entry{
  .dialog-modal{
    .dialog-footer{
      height: 59px;
    }
  }
}
.top {
  display: flex;
  align-items: flex-start;
  justify-content: center;

  .YH-login {
    flex: 1;
    padding-top: 0px;
    // width: 112px;
    height: 24px;
    line-height: 24px;
    font-size: 24px;
    // font-family: Microsoft YaHei;
    // font-weight: bold;
    text-align: center;
    color: #262626;
    margin: 48px 0 36px 0;
  }

  .SM-login {
    // width: 216px;
    // height: 24px;
    font-size: 26px;
    // font-family: Microsoft YaHei;
    // font-weight: bold;
    color: #262626;
    line-height: 31px;
    flex: 1;
    padding-top: 0px;
    text-align: center;
    margin-top: 48px;
  }
}

.loginErweima {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.login-form {
  flex: 1;
  width: 366px;
  height: 45px;
  .accountFun{
    display: flex;
    justify-content: space-between;
    .accountFunLeft{
      display: flex;
      justify-content: space-between;
      /deep/.el-checkbox{
        margin-right: 10px;
        height: 18px;
      }
    }
    .accountFunRight{
      width: 230px;
      display: flex;
      justify-content: end;
      flex-wrap:wrap;
      text-align: right;
    }
  }

  .button-solid {
    width: 100%;
    font-size: 20px;
  }
  .twoColumnLayout {
    display: flex;
    flex-direction: column;
    span {
      text-align: right;
    }
  }
  .link-forgetPwd {
    padding-left: 10px;
    float: right;
    font-size: 16px;
    color: #666;
    cursor: pointer;
    text-decoration: underline;

    &:hover,
    &:focus {
      color: #40a9ff;
    }

    &:active {
      color: #096dd9;
    }
  }

  .demo-container {
    display: flex;
    justify-content: space-between;
    align-items: center;

    .zhuce-hollow {
      display: flex;
      justify-content: center;
      // width: 150px;
      height: 45px;
      padding: 0px 32px;
      background: #ffffff;
      color: #1890ff;
      border: 1px solid #1890ff;
      border-radius: 4px;
      cursor: pointer;

      .iconfont {
        margin: 11px 8px;
        font-size: 20px;
      }

      &:hover,
      &:focus {
        border: 1px solid #40a9ff;
        background: #e6f7ff;
        color: #40a9ff;
      }

      &:active {
        border: 1px solid #096dd9;
        background: #e6f7ff;
        color: #096dd9;
      }

      .zhuce {
        margin: auto 8px;
        // margin-left: 8px;
        font-size: 16px;
        line-height: 21px; // margin: auto 39px auto 0;
      }
    }

    .shili-hollow {
      display: flex;
      justify-content: space-between;
      padding: 0px 32px;
      // width: 150px;
      height: 45px;
      color: #595959;
      background: #ffffff;
      border: 1px solid #d9d9d9;
      border-radius: 4px;
      cursor: pointer;

      .iconfont {
        margin: 11px 8px;
        font-size: 20px;
      }

      &:hover,
      &:focus {
        border: 1px solid #40a9ff;
        background: #ffffff;
        color: #40a9ff;
      }

      &:active {
        border: 1px solid #096dd9;
        background: #1890ff;
        color: #096dd9;
      }

      .sample {
        margin: auto 8px;
        font-size: 16px;
        line-height: 21px;
      }
    }
  }

  .WeChat {
    text-align: center;
    height: 30px;
    margin-top: 10px;
    padding: 15px;
    border: 1px solid #ffffff;
    border-bottom-color: #e5e5e5;

    .weixin {
      background: #ffffff;
      width: 90px;
      font-size: 12px;
      color: #8c8c8c;
      padding: 0 8px;
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin: 5px auto;
    }
  }

  .error-hollow {
    text-align: center;

    // display: flex;
    .error {
      // display: flex;
      // justify-content: center;
      // flex: 1;
      word-break: break-all;
      display: contents;
      font-size: 14px;
      color: #e4393c;
      width: 84px;
      height: 20px;
      font-weight: 400;
      color: rgba(229, 70, 77, 1);
    }
  }

  .yanzheng {
    display: flex;
    justify-content: space-between;

    .yanzhengma {
      width: 275px;
      height: 5vh;
    }

    .tupian {
      margin-left: 14px;
      width: 111px;
      height: 50px;
    }
  }

  /deep/ .el-input__prefix {
    width: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
  }
}

.contact {
  font-size: 14px;
  color: #666;

  .dialog-line {
    margin-bottom: 10px;
  }
}

.color-theme {
  color: #0367cc;
}

.PlantCode {
  .contactElse {
    .dialog-line {
      margin-bottom: 20px;
    }

    .color-theme {
      color: #0367cc;
      display: block;
      cursor: pointer;
    }
  }

  .contact {
    font-size: 14px;
    color: #666;

    .dialog-line {
      margin-bottom: 10px;
    }

    .color-theme {
      color: #0367cc;
    }
  }

  /deep/ .el-input .el-input__inner {
    background: #fff;
    border-color: #d9d9d9;
    height: 40px;
    line-height: 40px;

    &::placeholder {
      opacity: 1;
      font-size: 16px;
      font-family: Microsoft YaHei, Microsoft YaHei-Regular;
      font-weight: 400;
      color: #c0cfe3;
    }
  }
  .yzmInput{
    /deep/ .el-input .el-input__inner{
      padding-left: 10px;
    }
  }
}

// 邀请码弹窗输入框前置边距处理
/deep/.yzmBox .el-input .el-input__inner {
  padding-left: 10px;
}
    // ----------------------------------
    // 密码(如果需要切换时也更换眼睛图标) [+相邻 ~通用]
    /deep/ .el-input__inner[type="password"] ~ .el-input__suffix {
      .el-input__suffix-inner {
        // 眼睛隐藏
        .el-icon-view {
          &:before {
            content: "\e9e1"!important;
            font-family: "iconfont"!important;
            font-size: 16px!important;
          }
        }
      }
    }
    /deep/ .el-input__inner[type="text"] ~ .el-input__suffix {
      .el-input__suffix-inner {
        // 眼睛显示
        .el-icon-view {
          &:before {
            content: "\e9e3"!important;
            font-family: "iconfont"!important;
            font-size: 16px!important;
          }
        }
      }
    }
</style>
<style lang="less">
#slideVerifyCode {
  top: -150px;

  .dialog-container {
    box-shadow: 0px 6px 18px rgba(0, 39, 102, 0.9);
    height: 350px;
    width: 400px;

    .dialog-header {
      height: auto;
      justify-content: start;
      padding: 24px 24px;
      color: #363131;
      font-weight: normal;
    }

    .dialog-content {
      padding: 0px 24px;
      padding-bottom: 20px;
      overflow: hidden;
      //   .slide-verify {
      //       position: relative;
      //       width: 352px;
      //   }
      //   .slide-verify-slider {
      //       position: relative;
      //       text-align: center;
      //       width: 352px;
      //       height: 20px;
      //       line-height: 20px;
      //       margin-top: 24px;
      //       background: #f7f7f7;
      //       color: #45494c;
      //       border: 0px solid #e4e7eb
      //   }

      //   .slide-verify-slider-mask {
      //       position: absolute;
      //       left: 0;
      //       top: -5px;
      //       height: 32px;
      //       border-radius: 16px;
      //       border: 0 solid #1991FA;
      //       border-width:0px;
      //       // background: #D1E9FE
      //   }

      //   .slide-verify-slider-mask-item {
      //       position: absolute;
      //       top: -1px;
      //       left: 0;
      //       width: 64px;
      //       height: 32px;
      //       border-radius: 16px;
      //       box-shadow:0px 2px 6px rgba(0,39,102, 0.9);
      //       background: #fff;
      //   }
      //   .slide-verify-slider-mask-item:hover {
      //       background: #1991FA
      //   }
      .slide-verify-slider-mask-item-icon {
        background: url(../../assets/img/rightRight.png);
        background-size: 14px 12px;
      }

      .slide-verify-slider-mask-item:hover .slide-verify-slider-mask-item-icon {
        background: url(../../assets/img/right_white.png);
        background-size: 14px 12px;
      }

      .container-fail .slide-verify-slider-mask-item-icon {
        background: url(../../assets/img/chacha.png);
        background-size: 14px 12px;
      }

      .container-success .slide-verify-slider-mask-item-icon {
        background: url(../../assets/img/duigou.png);
        background-size: 14px 12px;
      }

      // .slide-verify-slider-mask-item-icon {
      //       position: absolute;
      //       top: 11px;
      //       left: 26px;
      //       width: 14px;
      //       height: 12px;
      //   }
    }
  }
}
</style>


